import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarAll from "../Navbar/NavbarAll";
import "./StudentProfile.css";

function getInitial(name) {
  const s = (name || "?").trim();
  return s.charAt(0).toUpperCase();
}

/** Qari view of a student profile — separate route from student My Profile */
export default function QariStudentProfile() {
  const { studentId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [student, setStudent] = useState(location.state?.student || null);
  const [loading, setLoading] = useState(!location.state?.student);
  const [error, setError] = useState("");
  const apiURL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const backFrom = location.state?.from || "progress";

  const goBack = () => {
    const resolvedId =
      studentId || student?.id || student?.uid || location.state?.student?.id;

    if (backFrom === "dashboard-qari" || !resolvedId) {
      navigate("/dashboard-qari");
      return;
    }

    const studentPayload = location.state?.student || student;
    navigate(`/dashboard-qari/students/${resolvedId}`, {
      state: { student: studentPayload, role: "teacher" },
    });
  };

  useEffect(() => {
    if (location.state?.student) {
      setStudent(location.state.student);
      setLoading(false);
      return;
    }

    if (!studentId || !token) {
      setError("Could not load student. Open from your class list.");
      setLoading(false);
      return;
    }

    const loadProfile = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(`${apiURL}/users/${studentId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStudent({ ...res.data, id: res.data.uid, uid: res.data.uid });
      } catch (err) {
        console.error("Failed to load student profile", err);
        setError(err.response?.data?.error || "Could not load student profile.");
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [location.state?.student, studentId, token, apiURL]);

  const deepLinkUrl = student?.deepLinkToken
    ? `https://zakariamasjid.com/dashboard-student?token=${student.deepLinkToken}`
    : student?.deepLink || null;

  const copyDeepLink = () => {
    if (!deepLinkUrl) return;
    navigator.clipboard?.writeText(deepLinkUrl).then(() => alert("Link copied!"));
  };

  return (
    <>
      <NavbarAll />
      <div className="hifz-profile-wrapper">
        <div className="hifz-profile-topbar" role="banner">
          <button type="button" className="hifz-profile-back-btn" onClick={goBack}>
            ← Back to progress
          </button>
          <h1 className="hifz-profile-title">Student Profile</h1>
        </div>

        <main className="hifz-profile-main">
          {loading && <div className="hifz-profile-loading">Loading profile…</div>}

          {!loading && error && (
            <div className="hifz-profile-error">
              <p>{error}</p>
              <button type="button" className="hifz-profile-back-btn" onClick={goBack}>
                ← Back
              </button>
            </div>
          )}

          {!loading && !error && student && (
            <div className="hifz-profile-card">
              <div className="hifz-profile-avatar" aria-hidden="true">
                {getInitial(student.name)}
              </div>
              <h2 className="hifz-profile-name">{student.name}</h2>
              <p className="hifz-profile-email">{student.email}</p>

              {deepLinkUrl && (
                <div className="hifz-profile-deeplink">
                  <span className="hifz-profile-deeplink-label">Student portal link</span>
                  <p className="hifz-profile-deeplink-url">{deepLinkUrl}</p>
                  <button
                    type="button"
                    className="hifz-profile-copy-btn"
                    onClick={copyDeepLink}
                  >
                    Copy link
                  </button>
                </div>
              )}
            </div>
          )}
        </main>
      </div>
    </>
  );
}
